// Account dropdown for mobile touch
const accountTrigger = document.querySelector('.account-trigger');
const accountDropdown = document.querySelector('.account-dropdown');

if (accountTrigger && window.innerWidth <= 1024) {
  accountTrigger.addEventListener('click', (e) => {
    e.stopPropagation();
    accountDropdown.classList.toggle('active');
  });

  document.addEventListener('click', (e) => {
    if (!accountDropdown.contains(e.target)) {
      accountDropdown.classList.remove('active');
    }
  });
}

let cartItems = [];
let currentDiscount = null;
let currentDiscountSavings = 0;
const FREE_SHIPPING_THRESHOLD = 40;

// Bundle discount codes mapping
const discountInfoMap = {
  'BUNDLE10': { percent: 10, name: '10% Bundle Discount', code: 'BUNDLE10', minItems: 3 },
  'BUNDLE15': { percent: 15, name: '15% Bundle Discount', code: 'BUNDLE15', minItems: 6 },
  'BUNDLE20': { percent: 20, name: '20% Bundle Discount', code: 'BUNDLE20', minItems: 9 }
};

// Check if discount code is stored in sessionStorage (set by bundle builder)
function checkForStoredDiscount() {
  const storedDiscount = sessionStorage.getItem('mamourse_discount');
  if (storedDiscount) {
    try {
      const discount = JSON.parse(storedDiscount);
      if (discount && discount.code && discountInfoMap[discount.code]) {
        currentDiscount = discountInfoMap[discount.code];
        return true;
      }
    } catch(e) {}
  }

  // Also check if discount is in URL params (for direct link)
  const urlParams = new URLSearchParams(window.location.search);
  const discountCode = urlParams.get('discount');
  if (discountCode && discountInfoMap[discountCode.toUpperCase()]) {
    currentDiscount = discountInfoMap[discountCode.toUpperCase()];
    sessionStorage.setItem('mamourse_discount', JSON.stringify({ code: currentDiscount.code, percent: currentDiscount.percent }));
    return true;
  }

  return false;
}

// Apply discount to subtotal
function applyDiscount(subtotal) {
  if (currentDiscount) {
    currentDiscountSavings = subtotal * (currentDiscount.percent / 100);
    return subtotal - currentDiscountSavings;
  }
  currentDiscountSavings = 0;
  return subtotal;
}

// Get free shipping status
function getFreeShippingStatus(subtotal) {
  return subtotal >= FREE_SHIPPING_THRESHOLD;
}

// Get free shipping progress message
function getFreeShippingProgress(subtotal) {
  if (subtotal >= FREE_SHIPPING_THRESHOLD) {
    return null;
  }
  const needed = FREE_SHIPPING_THRESHOLD - subtotal;
  return `✨ Add $${needed.toFixed(2)} more for FREE shipping!`;
}

function normalizeProperties(properties) {
  if (!properties || typeof properties !== 'object') return {};
  return properties;
}

function propertiesAreEqual(a, b) {
  return JSON.stringify(normalizeProperties(a)) === JSON.stringify(normalizeProperties(b));
}

function isMeaningfulVariantValue(value) {
  if (value === null || value === undefined) return false;
  const str = String(value).trim();
  if (!str) return false;
  return str.toLowerCase() !== 'default title';
}

function normalizeVariantOptions(options) {
  if (!options) return [];

  if (Array.isArray(options)) {
    return options
      .map(option => String(option || '').trim())
      .filter(option => isMeaningfulVariantValue(option));
  }

  if (typeof options === 'object') {
    return Object.keys(options)
      .map(key => {
        const value = options[key];
        if (!isMeaningfulVariantValue(value)) return '';
        return `${key}: ${value}`;
      })
      .filter(Boolean);
  }

  if (isMeaningfulVariantValue(options)) {
    return [String(options).trim()];
  }

  return [];
}

function getVariantDataFromProductData(productData) {
  productData = productData || {};

  const possibleVariantObjects = [
    productData.variant,
    productData.selectedVariant,
    productData.selected_variant
  ].filter(Boolean);

  const possibleVariantTitles = [
    productData.variant_title,
    productData.variantTitle,
    productData.variant_name,
    productData.variantName,
    productData.selected_variant_title,
    productData.selectedVariantTitle,
    productData.selected_variant_name,
    productData.selectedVariantName
  ];

  possibleVariantObjects.forEach(variant => {
    possibleVariantTitles.push(variant.title, variant.name, variant.variant_title, variant.variantTitle);
  });

  let variantTitle = '';
  for (const title of possibleVariantTitles) {
    if (isMeaningfulVariantValue(title)) {
      variantTitle = String(title).trim();
      break;
    }
  }

  const variantOptions = [];

  [
    productData.variant_options,
    productData.variantOptions,
    productData.selected_options,
    productData.selectedOptions,
    productData.options
  ].forEach(options => {
    normalizeVariantOptions(options).forEach(option => variantOptions.push(option));
  });

  possibleVariantObjects.forEach(variant => {
    normalizeVariantOptions(variant.options).forEach(option => variantOptions.push(option));
    normalizeVariantOptions(variant.selected_options).forEach(option => variantOptions.push(option));
    normalizeVariantOptions(variant.selectedOptions).forEach(option => variantOptions.push(option));

    ['option1', 'option2', 'option3'].forEach(optionKey => {
      if (isMeaningfulVariantValue(variant[optionKey])) {
        variantOptions.push(String(variant[optionKey]).trim());
      }
    });
  });

  ['option1', 'option2', 'option3'].forEach(optionKey => {
    if (isMeaningfulVariantValue(productData[optionKey])) {
      variantOptions.push(String(productData[optionKey]).trim());
    }
  });

  const uniqueOptions = [];
  variantOptions.forEach(option => {
    const cleanOption = String(option || '').trim();
    if (cleanOption && !uniqueOptions.includes(cleanOption)) {
      uniqueOptions.push(cleanOption);
    }
  });

  return {
    variant_title: variantTitle,
    variant_options: uniqueOptions
  };
}

function formatVariantForDisplay(item) {
  if (!item) return '';

  if (isMeaningfulVariantValue(item.variant_title)) {
    return String(item.variant_title).trim();
  }

  const options = normalizeVariantOptions(item.variant_options);
  if (options.length > 0) {
    return options.join(' / ');
  }

  const fallbackOptions = [];
  ['option1', 'option2', 'option3'].forEach(optionKey => {
    if (isMeaningfulVariantValue(item[optionKey])) {
      fallbackOptions.push(String(item[optionKey]).trim());
    }
  });

  if (fallbackOptions.length > 0) {
    return fallbackOptions.join(' / ');
  }

  return '';
}

const variantDetailsCache = {};

async function fetchVariantDetailsById(variantId) {
  if (!variantId) return null;

  const cacheKey = String(variantId);
  if (variantDetailsCache[cacheKey]) {
    return variantDetailsCache[cacheKey];
  }

  try {
    const response = await fetch(`/variants/${encodeURIComponent(cacheKey)}.js`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      return null;
    }

    const variant = await response.json();
    variantDetailsCache[cacheKey] = variant;
    return variant;
  } catch (error) {
    console.warn('Could not fetch variant details for WhatsApp checkout:', error);
    return null;
  }
}

async function ensureCartItemVariantData(item) {
  if (!item) return item;

  if (formatVariantForDisplay(item)) {
    return item;
  }

  const variant = await fetchVariantDetailsById(item.variant_id);
  if (!variant) {
    return item;
  }

  if (isMeaningfulVariantValue(variant.title)) {
    item.variant_title = String(variant.title).trim();
  }

  const fetchedOptions = [];
  ['option1', 'option2', 'option3'].forEach(optionKey => {
    if (isMeaningfulVariantValue(variant[optionKey])) {
      fetchedOptions.push(String(variant[optionKey]).trim());
    }
  });

  if (fetchedOptions.length > 0) {
    item.variant_options = fetchedOptions;
  }

  return item;
}

function updateCartUI() {
  const container = document.getElementById('cartDrawerContent');
  const cartTotalSpan = document.getElementById('cartTotal');
  const cartSubtotalSpan = document.getElementById('cartSubtotal');
  const cartDiscountRow = document.getElementById('cartDiscountRow');
  const cartDiscountAmountSpan = document.getElementById('cartDiscountAmount');
  const cartCountEl = document.querySelector('.cart-count');
  const checkoutButton = document.getElementById('checkoutButton');
  const discountBadge = document.getElementById('discountBadge');
  const freeShippingMessage = document.getElementById('freeShippingMessage');
  const freeShippingProgress = document.getElementById('freeShippingProgress');

  if (!container) return;

  if (cartItems.length === 0) {
    container.innerHTML = `<div class="cart-empty-message">🧸 Your cart is cozy & empty. Add something sweet 💕<br><small>Making motherhood easier, one moment at a time 🤍</small></div>`;
    if (cartTotalSpan) cartTotalSpan.innerText = `0.00 USD`;
    if (cartSubtotalSpan) cartSubtotalSpan.innerText = `0.00 USD`;
    if (cartCountEl) cartCountEl.innerText = '0';
    if (checkoutButton) checkoutButton.disabled = true;
    if (discountBadge) discountBadge.style.display = 'none';
    if (cartDiscountRow) cartDiscountRow.style.display = 'none';
    if (freeShippingMessage) freeShippingMessage.style.display = 'none';
    if (freeShippingProgress) freeShippingProgress.style.display = 'none';
    return;
  }

  let subtotal = 0;
  let itemCount = 0;
  container.innerHTML = '';

  cartItems.forEach((item, idx) => {
    subtotal += item.price * item.qty;
    itemCount += item.qty;
    const div = document.createElement('div');
    div.className = 'cart-item';

    let propertiesHtml = '';
    if (item.properties && Object.keys(item.properties).length > 0) {
      propertiesHtml = `<div class="cart-item-properties" style="font-size: 11px; color: #5c6f7e; margin-bottom: 8px;">`;
      Object.keys(item.properties).forEach(key => {
        propertiesHtml += `<div><strong>${escapeHtml(key)}:</strong> ${escapeHtml(String(item.properties[key]))}</div>`;
      });
      propertiesHtml += `</div>`;
    }

    div.innerHTML = `
  <div class="cart-item-inner">
    ${
      item.image
        ? `<img src="${item.image}" alt="${escapeHtml(item.title)}" class="cart-item-image" loading="lazy">`
        : `<div class="cart-item-image" style="display:flex;align-items:center;justify-content:center;font-size:24px;">🧸</div>`
    }

    <div class="cart-item-details">
      <div class="cart-item-title">
        ${escapeHtml(item.title || 'Mamourse Product')}
      </div>

      <div class="cart-item-price">
        $${item.price.toFixed(2)} <span>USD</span>
      </div>

      ${propertiesHtml || ''}

      <div class="cart-quantity-controls">
        <button class="cart-qty-btn" data-action="dec" data-idx="${idx}" type="button">−</button>
        <span class="cart-qty-number">${item.qty}</span>
        <button class="cart-qty-btn" data-action="inc" data-idx="${idx}" type="button">+</button>
      </div>
    </div>

    <button class="cart-item-remove" data-action="remove" data-idx="${idx}" aria-label="Remove item" type="button">
      <svg viewBox="0 0 24 24">
        <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
      </svg>
    </button>
  </div>
`;
    container.appendChild(div);
  });

  // Apply discount
  const finalTotal = applyDiscount(subtotal);
  const freeShipping = getFreeShippingStatus(subtotal);
  const progressMsg = getFreeShippingProgress(subtotal);

  // Update totals display
  if (cartSubtotalSpan) cartSubtotalSpan.innerText = `${subtotal.toFixed(2)} USD`;
  if (cartTotalSpan) cartTotalSpan.innerText = `${finalTotal.toFixed(2)} USD`;
  if (cartCountEl) cartCountEl.innerText = itemCount;
  if (checkoutButton) checkoutButton.disabled = false;

  // Update discount row
  if (currentDiscount && currentDiscountSavings > 0) {
    if (cartDiscountRow) cartDiscountRow.style.display = 'flex';
    if (cartDiscountAmountSpan) cartDiscountAmountSpan.innerText = `-$${currentDiscountSavings.toFixed(2)} USD`;
    if (discountBadge) discountBadge.style.display = 'inline-block';
  } else {
    if (cartDiscountRow) cartDiscountRow.style.display = 'none';
    if (discountBadge) discountBadge.style.display = 'none';
  }

  // Update free shipping
  if (freeShipping) {
    if (freeShippingMessage) freeShippingMessage.style.display = 'block';
    if (freeShippingProgress) freeShippingProgress.style.display = 'none';
  } else {
    if (freeShippingMessage) freeShippingMessage.style.display = 'none';
    if (freeShippingProgress) {
      if (progressMsg && subtotal > 0) {
        freeShippingProgress.style.display = 'block';
        freeShippingProgress.innerHTML = progressMsg;
      } else {
        freeShippingProgress.style.display = 'none';
      }
    }
  }

  // Re-attach event listeners
  document.querySelectorAll('.cart-qty-btn, .cart-item-remove').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const action = btn.dataset.action;
      const idx = parseInt(btn.dataset.idx);
      if (action === 'inc') {
        cartItems[idx].qty += 1;
      } else if (action === 'dec') {
        if (cartItems[idx].qty > 1) {
          cartItems[idx].qty -= 1;
        } else {
          cartItems.splice(idx, 1);
        }
      } else if (action === 'remove') {
        cartItems.splice(idx, 1);
      }
      updateCartUI();
      saveToLocal();
    });
  });
}

function escapeHtml(str) {
  if (!str) return '';
  return str.replace(/[&<>]/g, function(m) {
    if (m === '&') return '&amp;';
    if (m === '<') return '&lt;';
    if (m === '>') return '&gt;';
    return m;
  });
}

function saveToLocal() {
  localStorage.setItem('mamourse_cart', JSON.stringify(cartItems));
}

function saveGiftCheckboxToLocal() {
  const giftCheckbox = document.getElementById('giftCheckbox');
  if (giftCheckbox) {
    localStorage.setItem('mamourse_gift_checkbox', giftCheckbox.checked ? 'true' : 'false');
  }
}

function loadGiftCheckboxFromLocal() {
  const giftCheckbox = document.getElementById('giftCheckbox');
  const savedGiftState = localStorage.getItem('mamourse_gift_checkbox');

  if (giftCheckbox) {
    giftCheckbox.checked = savedGiftState === 'true';
  }
}

function loadCart() {
  const saved = localStorage.getItem('mamourse_cart');
  if (saved) {
    try {
      const parsedCart = JSON.parse(saved);
      cartItems = Array.isArray(parsedCart) ? parsedCart : [];
    } catch (e) {
      cartItems = [];
    }
  }
  checkForStoredDiscount();
  loadGiftCheckboxFromLocal();
  updateCartUI();
}

window.addToCart = function(productData) {
  productData = productData || {};

  const incomingProperties = normalizeProperties(productData.properties || productData.customization || {});
  const incomingVariantData = getVariantDataFromProductData(productData);

  const existingItemIndex = cartItems.findIndex(item => {
    return String(item.variant_id) === String(productData.variant_id) && propertiesAreEqual(item.properties || {}, incomingProperties);
  });

  if (existingItemIndex > -1) {
    cartItems[existingItemIndex].qty += productData.quantity || 1;

    if (!formatVariantForDisplay(cartItems[existingItemIndex])) {
      cartItems[existingItemIndex].variant_title = incomingVariantData.variant_title || cartItems[existingItemIndex].variant_title || '';
      cartItems[existingItemIndex].variant_options = incomingVariantData.variant_options.length ? incomingVariantData.variant_options : (cartItems[existingItemIndex].variant_options || []);
    }
  } else {
    cartItems.push({
      variant_id: productData.variant_id,
      title: productData.title || 'Mamourse Product',
      price: parseFloat(productData.price) || 0,
      qty: productData.quantity || 1,
      image: productData.image || '',
      properties: incomingProperties,
      variant_title: incomingVariantData.variant_title || '',
      variant_options: incomingVariantData.variant_options || []
    });
  }
  updateCartUI();
  saveToLocal();
  openCartDrawer();
  return cartItems;
};

window.applyBundleDiscount = function(discountCode) {
  if (discountInfoMap[discountCode]) {
    currentDiscount = discountInfoMap[discountCode];
    sessionStorage.setItem('mamourse_discount', JSON.stringify({ code: currentDiscount.code, percent: currentDiscount.percent }));
    updateCartUI();
    return true;
  }
  return false;
};

window.getCurrentDiscount = function() {
  return currentDiscount;
};

function openCartDrawer() {
  document.getElementById('cartDrawer')?.classList.add('active');
  document.getElementById('cartOverlay')?.classList.add('active');
  document.body.classList.add('roux-cart-open');
  document.body.style.overflow = 'hidden';
  // Refresh cart UI when opening
  updateCartUI();
}

function closeCartDrawer() {
  document.getElementById('cartDrawer')?.classList.remove('active');
  document.getElementById('cartOverlay')?.classList.remove('active');
  document.body.classList.remove('roux-cart-open');
  document.body.style.overflow = '';
}

// WhatsApp Checkout Function with discounted total
async function checkoutThroughWhatsApp() {
  if (cartItems.length === 0) {
    alert('🧸 Your cart is empty. Add some items before checking out. 🤍');
    return;
  }

  await Promise.all(cartItems.map(item => ensureCartItemVariantData(item)));
  saveToLocal();

  let subtotal = 0;
  let cartMessage = "🛒 *My Mamourse Cart* 🛒\n\n";

  cartItems.forEach((item, index) => {
    const itemTotal = item.price * item.qty;
    const variantDisplay = formatVariantForDisplay(item);

    subtotal += itemTotal;
    cartMessage += `${index + 1}. ${item.title}\n`;

    if (variantDisplay) {
      cartMessage += `   Variant: ${variantDisplay}\n`;
    } else if (item.variant_id) {
      cartMessage += `   Variant ID: ${item.variant_id}\n`;
    }

    cartMessage += `   Quantity: ${item.qty}\n`;
    cartMessage += `   Price: $${item.price.toFixed(2)} each\n`;

    if (item.properties && Object.keys(item.properties).length > 0) {
      cartMessage += `   Customization:\n`;
      Object.keys(item.properties).forEach(key => {
        cartMessage += `   - ${key}: ${item.properties[key]}\n`;
      });
    }

    cartMessage += `   Subtotal: $${itemTotal.toFixed(2)}\n\n`;
  });

  const giftCheckbox = document.getElementById('giftCheckbox');
  if (giftCheckbox && giftCheckbox.checked) {
    cartMessage += `🎁 *Gift Order: Yes*\n\n`;
  }

  const finalTotal = currentDiscount ? subtotal - currentDiscountSavings : subtotal;

  cartMessage += `━━━━━━━━━━━━━━━━━━\n`;
  cartMessage += `💰 *Subtotal: $${subtotal.toFixed(2)} USD*\n`;
  if (currentDiscount) {
    cartMessage += `🎉 *Discount (${currentDiscount.name}): -$${currentDiscountSavings.toFixed(2)}*\n`;
  }
  cartMessage += `💵 *Total: $${finalTotal.toFixed(2)} USD*\n\n`;
  cartMessage += `📍 Customer Location: To be provided\n`;
  cartMessage += `📝 Please confirm my order and provide payment details. Thank you! 🤍\n\n`;
  cartMessage += `✨ Making motherhood easier, one moment at a time ✨`;

  const encodedMessage = encodeURIComponent(cartMessage);
  const whatsappNumber = '96181242131';
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

  window.open(whatsappUrl, '_blank');
  closeCartDrawer();
}

async function sendLocalCartToShopifyCheckout() {
  const checkoutButton = document.getElementById('checkoutButton');

  if (!cartItems.length) {
    alert('✨ Your cart is waiting for some love 🤍');
    return;
  }

  if (checkoutButton) {
    checkoutButton.disabled = true;
    checkoutButton.innerText = 'Redirecting to checkout...';
  }

  try {
    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const giftCheckbox = document.getElementById('giftCheckbox');

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          "Gift Order": giftCheckbox && giftCheckbox.checked ? "Yes" : "No"
        }
      })
    });

    const items = cartItems.map(item => ({
      id: Number(item.variant_id),
      quantity: item.qty || 1,
      properties: item.properties || {}
    }));

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!addResponse.ok) {
      throw new Error('Shopify cart add failed');
    }

    if (currentDiscount && currentDiscount.code) {
      window.location.href = `/discount/${currentDiscount.code}?redirect=/checkout`;
    } else {
      window.location.href = '/checkout';
    }

  } catch (error) {
    console.error('Checkout error:', error);
    alert('Could not open checkout. Please try again.');

    if (checkoutButton) {
      checkoutButton.disabled = false;
      checkoutButton.innerText = 'Proceed to checkout 🤍';
    }
  }
}

document.getElementById('cartButton')?.addEventListener('click', openCartDrawer);
document.getElementById('closeCart')?.addEventListener('click', closeCartDrawer);
document.getElementById('cartOverlay')?.addEventListener('click', closeCartDrawer);

const checkoutButton = document.getElementById('checkoutButton');
if (checkoutButton) {
  checkoutButton.addEventListener('click', sendLocalCartToShopifyCheckout);
}

const whatsappCheckoutBtn = document.getElementById('whatsappCheckoutBtn');
if (whatsappCheckoutBtn) {
  whatsappCheckoutBtn.addEventListener('click', (e) => {
    e.preventDefault();
    checkoutThroughWhatsApp();
  });
}

const giftCheckbox = document.getElementById('giftCheckbox');
if (giftCheckbox) {
  giftCheckbox.addEventListener('change', saveGiftCheckboxToLocal);
}

const mobileToggle = document.querySelector('.mobile-menu-toggle');
const mobileMenu = document.getElementById('mobileMenu');
if(mobileToggle && mobileMenu) {
  mobileToggle.addEventListener('click', function(e) {
    e.stopPropagation();
    mobileMenu.classList.toggle('active');
    this.classList.toggle('active');
    document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
  });
  document.querySelectorAll('.mobile-menu-item').forEach(link => {
    link.addEventListener('click', () => {
      mobileMenu.classList.remove('active');
      mobileToggle.classList.remove('active');
      document.body.style.overflow = '';
    });
  });
}

loadCart();

function updateHeights() {
  const annH = document.getElementById('announcementBar')?.offsetHeight || 38;
  const headH = document.querySelector('.mamourse-header')?.offsetHeight || 70;
  const topOffset = annH + headH;

  const viewportH =
    window.visualViewport && window.visualViewport.height
      ? window.visualViewport.height
      : window.innerHeight;

  const availableH = Math.max(viewportH - topOffset, 320);

  document.documentElement.style.setProperty('--announcement-h', annH + 'px');
  document.documentElement.style.setProperty('--header-h', headH + 'px');
  document.documentElement.style.setProperty('--cart-top-offset', topOffset + 'px');
  document.documentElement.style.setProperty('--cart-height', availableH + 'px');

  document.body.style.paddingTop = `${topOffset}px`;

  const mobileMenuEl = document.getElementById('mobileMenu');
  if (mobileMenuEl) {
    mobileMenuEl.style.top = `${topOffset}px`;
    mobileMenuEl.style.height = `${availableH}px`;
  }

  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');

  if (cartDrawer) {
    cartDrawer.style.top = `${topOffset}px`;
    cartDrawer.style.height = `${availableH}px`;
    cartDrawer.style.maxHeight = `${availableH}px`;
  }

  if (cartOverlay) {
    cartOverlay.style.top = `${topOffset}px`;
    cartOverlay.style.height = `${availableH}px`;
  }
}

window.addEventListener('resize', () => {
  setTimeout(updateHeights, 50);
});

window.addEventListener('orientationchange', () => {
  setTimeout(updateHeights, 250);
});

if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', () => {
    setTimeout(updateHeights, 50);
  });

  window.visualViewport.addEventListener('scroll', () => {
    setTimeout(updateHeights, 50);
  });
}

document.addEventListener('DOMContentLoaded', updateHeights);
updateHeights();

/* ===== MOBILE LOGO REDIRECT FIX ===== */

document.querySelectorAll('.logo-container').forEach(logo => {
  logo.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/';
  });
});